import React from 'react';
import { Screen } from '~/screens/users/[id]/edit';

export const UserEdit: React.FC = () => <Screen />;
